// Fork: inputs for a note's time and a public update's status label.
import { useId } from 'react'
import { STATUS_LABEL_OPTIONS, nowInputValue } from './noteTime'

const INPUT_CLASS = 'px-2 py-1 border border-border rounded-md text-sm bg-white focus:outline-none focus:ring-2 focus:ring-brand-primary disabled:opacity-50'

export function NoteTimeInput({ value, onChange, disabled, placeholderNow }: {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  placeholderNow?: boolean
}) {
  const id = useId()
  return (
    <div className="flex flex-wrap items-center gap-2">
      <label htmlFor={id} className="text-sm text-text-secondary">Time</label>
      <input id={id} type="datetime-local" value={value} max={nowInputValue()} onChange={e => onChange(e.target.value)} disabled={disabled} className={INPUT_CLASS} />
      {placeholderNow && value === '' && <span className="text-xs text-text-tertiary">Now</span>}
      {placeholderNow && value !== '' && (
        <button type="button" onClick={() => onChange('')} disabled={disabled} className="text-xs text-text-tertiary hover:text-text-primary underline">Use now</button>
      )}
    </div>
  )
}

export function StatusLabelInput({ value, onChange, disabled }: {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}) {
  const id = useId()
  return (
    <div className="flex flex-wrap items-center gap-2">
      <label htmlFor={id} className="text-sm text-text-secondary">Status label</label>
      <input id={id} list={`${id}-options`} value={value} maxLength={40} onChange={e => onChange(e.target.value)} disabled={disabled} placeholder="Investigating" className={INPUT_CLASS} />
      <datalist id={`${id}-options`}>
        {STATUS_LABEL_OPTIONS.map(option => <option key={option} value={option} />)}
      </datalist>
    </div>
  )
}
